import React from "react";
import LoaderGif from "@/assets/gif/preloader.gif";
import Image from "next/image";

const LoadingOverlay = () => {
  return (
    <div className="page-transition-loader fixed left-0 top-0 z-50 flex h-screen w-full items-center justify-center bg-black/30">
      <Image src={LoaderGif} height={150} alt="loading" />
    </div>
  );
};

export default LoadingOverlay;
